import PropTypes from 'prop-types';
import EmailCardSkeleton from './card/email-card-skeleton';

const EmailListSkeleton = ({ count = 8 }) => {
  return (
    <div className="skeleton-email-list-container">
      <div className="skeleton-title" />
      <div className="skeleton-email-list">
        {Array(count)
          .fill()
          .map((_, index) => (
            <EmailCardSkeleton key={`skeleton-${index}`} />
          ))}
      </div>
    </div>
  );
};

EmailListSkeleton.propTypes = {
  count: PropTypes.number,
};

export default EmailListSkeleton;
